// removed by extract-text-webpack-plugin
module.exports = {"toggle-button":"ToggleButton__toggle-button___36kg7","toggle-button-input":"ToggleButton__toggle-button-input___HSIqT","toggle-button-label":"ToggleButton__toggle-button-label___wgjM3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ToggleButton/ToggleButton.css
// module id = 712
// module chunks = 0